module.exports = __webpack_public_path__ + "static/ux_paris_157-8dab955d1a517c765d20d243697439eb.jpg";